module.exports = require('./helpers/bundle-url').getBundleURL('8GXGR') + "logo-dark.ba5147f0.svg";